import { Component } from '@angular/core';

@Component({
  selector: 'app-error-page-layout',
  standalone: true,
  templateUrl: './error-page-layout.component.html'
})
export class ErrorPageLayoutComponent {}
